<template>
  <section>
    <Title :title-name="title.SelectService.titleName" :title-link="title.SelectService.titleLink" />
    <div class="select_service">
      <div class="container" style="padding: 14pt">
        <p>Dear {{ pax.title }} {{ pax.first_name }} {{ pax.last_name }},</p>
        Unfortunately your flight {{ pax.flight_number }} is cancelled, therefor we would like to offer you one of the following
        options according to EU-261 regulations.
      </div>
      <div class="block-item">
        <div class="container">
          <h2 class="title" style="font-size: 16pt; width: 100%; margin: 0">
            Option 1 Re-routing, on the next available flight to your final destination
          </h2>
        </div>
      </div>
      <div class="container" style="padding: 14pt">
        <p>If you select this option you will be provided with:</p>
        <h2 class="title sb_mobile sb_refreshment" style="font-size: 16pt; padding-left: 45pt; width: 100%; margin: 0">
          Meals and refreshments in reasonable relation to the waiting time.
        </h2>
        <h2 class="title sb_mobile sb_message" style="font-size: 16pt; padding-left: 45pt; width: 100%; margin: 0">
          Two telephone calls, fax messages or e-mails.
        </h2>
        <h2 class="title sb_mobile sb_hotel" style="font-size: 16pt; padding-left: 45pt; width: 100%; margin: 0">
          Reasonable hotel accommodation when a stay of one or more nights becomes necessary.
        </h2>
        <h2 class="title sb_mobile sb_bus" style="font-size: 16pt; padding-left: 45pt; width: 100%; margin: 0">
          Reasonable transport between the airport and place of accommodation (hotel or other).
        </h2>
        <router-link :to="{ name: selectService, query: { secret: secret } }">
          <div class="text-right">
            <a class="btnOrange" style="text-decoration: none">SELECT THIS OPTION</a>
          </div>
        </router-link>
      </div>
      <div class="block-item">
        <div class="container">
          <h2 class="title" style="font-size: 16pt; width: 100%; margin: 0">Option 2 Re-routing, on a future flight</h2>
        </div>
      </div>
      <div class="container" style="padding: 14pt">
        <p>Re-routing, on a future flight to your final destination at a later date at your convenience.</p>
        <router-link :to="{ name: 'ServiceOptionRouting', query: { secret: secret } }">
          <div class="text-right">
            <a class="btnOrange" style="text-decoration: none">SELECT THIS OPTION</a>
          </div>
        </router-link>
      </div>
      <div class="block-item">
        <div class="container">
          <h2 class="title" style="font-size: 16pt; width: 100%; margin: 0">Option 3 Full Refund</h2>
        </div>
      </div>
      <div class="container" style="padding: 14pt">
        <p>
          We will provide a full refund of the unused flights in passengers booking.<br />
          (If you chose to make alternative transport arrangements i.e. care hire, trains, ferries etc. These are not covered
          under EU261 and therefore expense clams should be directed to your travel insurance company.)
        </p>
        <router-link :to="{ name: 'ServiceOptionRefund', query: { secret: secret } }">
          <div class="text-right">
            <a class="btnOrange" style="text-decoration: none">SELECT THIS OPTION</a>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/SelectService.scss'
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'
import moment from 'moment'
import Title from '@/components/Title/index'

export default {
  name: 'SelectService',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectService: 'SelectManualService',
      hasRebook: false,
      dateDiff: 0,
      isNextDate: true,
      mobileFlow: 1 //this.$store.getters.airline.params.mobile_flow,
    }
  },
  computed: {
    ...mapGetters({
      SelectService: 'SelectService/SelectService',
      Rebook: 'SelectService/Rebook',
      FlightHistory: 'SelectService/FlightHistory',
      PaxsGroup: 'SelectService/PaxsGroup'
    })
  },
  mounted() {
    this.$store.dispatch('SelectService/getSelectService')
    this.$store.dispatch('SelectService/getRebook')
    this.$store.dispatch('SelectService/getFlightHistory')
    this.$store.dispatch('SelectService/getPaxsGroup')
    if (this.mobileFlow) {
      if (this.Rebook) {
        this.hasRebook = true
        let duration = moment.duration(
          moment(this.Rebook.date, ['YYYY-MM-DDTHH:mm:ss']).diff(moment(this.FlightHistory.std, ['YYYY-MM-DDTHH:mm:ss']))
        )
        this.dateDiff = duration.asHours()
        this.isNextDate =
          moment(this.Rebook.date, 'YYYY-MM-DDTHH:mm:ss') > moment(this.FlightHistory.std, ['YYYY-MM-DDTHH:mm:ss'])
      }
      if ((!this.SelectService[17] || !this.SelectService[18]) && !this.hasRebook) {
        // Has not service rebook assign
        this.selectService = 'WaitRebook'
      } else {
        if (this.dateDiff < 24 && this.hasRebook && !this.isNextDate) {
          //3: If no RE-BOOK in today and wait time > then 2 hour
          this.selectService = 'FlyToDay'
        } else if (this.isNextDate && this.hasRebook) {
          //1: If has RE-BOOK to next day
          this.selectService = 'FlightNextDay'
        } else {
          this.selectService = 'OverbookedPassenger'
        }
      }
    }
  },
  methods: {
    replaceStr
  }
}
</script>
